"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterRatesByProductAndCommission = void 0;
function filterRatesByProductAndCommission(rates, product, commission) {
    return rates.filter(rate => rate.product === product).filter(rate => rate.commissionOption === commission);
}
exports.filterRatesByProductAndCommission = filterRatesByProductAndCommission;
//# sourceMappingURL=product-commission-filterer.js.map